module.exports = __webpack_public_path__ + "static/media/about_img3.618734aa.jpg";